// Slideshow
(function () {
  $('.js-slideshow').each(function () {
    let $slideshow = $(this),
        $items     = $slideshow.find('.js-slideshow-item'),
        speed      = $slideshow.data('speed') || 4000,
        current    = 0;

    let interval = setInterval(() => {
      current = (current + 1) % $items.length;
      $items.addClass('is-hidden').eq(current).removeClass('is-hidden');
    }, speed);
  });
})();
